import { DeficiencyItemFormModel } from '..';

export default function getPayload(deficiencyItem: DeficiencyItemFormModel) {
  return deficiencyItem;
}
